import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { OrgTemplateAadService, OrgTemplateAadCredentials } from '../../../../services/org-template-aad.service';
import { NotificationService } from '../../../../services/notification.service';

@Component({
  selector: 'app-ua-credentials-card',
  templateUrl: './ua-credentials-card.component.html',
  styleUrls: ['./ua-credentials-card.component.css']
})
export class UaCredentialsCardComponent implements OnInit {
  @Input() templateId!: string;
  /**
   * When set, credentials are fetched from the class-scoped endpoint
   * (`CustomerCloudIds[classId]`) instead of the org-template record.
   * Leave unset for org-template (resource-cards) contexts.
   */
  @Input() classId?: string;
  @Input() hideClose = false;
  @Output() close = new EventEmitter<void>();

  credentials: OrgTemplateAadCredentials | null = null;
  isLoading = false;
  tapVisible = false;

  constructor(
    private aadService: OrgTemplateAadService,
    private notification: NotificationService,
    private clipboard: Clipboard
  ) {}

  ngOnInit(): void {
    this.loadCredentials();
  }

  loadCredentials(): void {
    this.isLoading = true;
    const fetch$ = this.classId
      ? this.aadService.getClassTemplateCredentials(this.templateId, this.classId)
      : this.aadService.getCredentials(this.templateId);

    fetch$.subscribe({
      next: creds => {
        this.credentials = creds;
        this.isLoading = false;
      },
      error: () => {
        this.notification.error('Failed to load credentials');
        this.isLoading = false;
      }
    });
  }

  toggleTapVisibility(): void {
    this.tapVisible = !this.tapVisible;
  }

  copyToClipboard(value: string, label: string): void {
    this.clipboard.copy(value);
    this.notification.success(`${label} copied to clipboard`);
  }

  openAzurePortal(): void {
    window.open('https://portal.azure.com', '_blank', 'noopener noreferrer');
  }
}
